import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { stopMixtape } from 'store/playerSlice';

// Short burst of decaying static — an old radio being switched off.
const crackle = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    ctx.resume?.();
    const dur = 0.3;
    const buf = ctx.createBuffer(1, Math.floor(ctx.sampleRate * dur), ctx.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < data.length; i += 1) {
      const env = (1 - i / data.length) ** 2;
      const pop = Math.random() < 0.04 ? Math.random() * 2 - 1 : (Math.random() * 2 - 1) * 0.15;
      data[i] = pop * env;
    }
    const src = ctx.createBufferSource();
    src.buffer = buf;
    const filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.frequency.value = 1400;
    filter.Q.value = 0.6;
    const gain = ctx.createGain();
    gain.gain.value = 0.5;
    src.connect(filter).connect(gain).connect(ctx.destination);
    src.onended = () => ctx.close();
    src.start();
  } catch {
    // audio unavailable — skip the effect
  }
};

// CRT power-off: the picture squeezes toward the center, a bright line
// snaps in and collapses to a dot, then blackout. Any audio gets a quick
// crackling fade-out first, like a radio being turned off.
const TvOff = () => {
  const mixtape = useSelector((s) => s.player.mixtape);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!mixtape) return undefined;

    const audios = [...document.querySelectorAll('audio')].filter(
      (a) => !a.paused
    );
    if (!audios.length) {
      dispatch(stopMixtape());
      return undefined;
    }

    crackle();
    const starts = audios.map((a) => a.volume);
    let p = 0;
    const iv = setInterval(() => {
      p += 1 / 8;
      audios.forEach((a, i) => {
        a.volume = Math.max(0, starts[i] * (1 - p));
      });
      if (p >= 1) {
        clearInterval(iv);
        dispatch(stopMixtape());
      }
    }, 40);
    return () => clearInterval(iv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Once the set is off, a click or Enter powers back to the login screen.
  // Delayed so the interaction that triggered the power-off doesn't bounce.
  useEffect(() => {
    const go = () => window.location.assign('/');
    const onKey = (e) => {
      if (e.key === 'Enter') go();
    };
    const t = setTimeout(() => {
      window.addEventListener('click', go);
      window.addEventListener('keydown', onKey);
    }, 800);
    return () => {
      clearTimeout(t);
      window.removeEventListener('click', go);
      window.removeEventListener('keydown', onKey);
    };
  }, []);

  return (
    <div className="tvoff">
      <div className="tvoff-shutter tvoff-top" />
      <div className="tvoff-shutter tvoff-bottom" />
      <div className="tvoff-line" />
    </div>
  );
};

export default TvOff;
